export default "/assets/images/badge-01.png?de55f8e6887734847f33a0d8fdb3f0ca";